var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CommonTable',{attrs:{"headers":_vm.headers,"items":_vm.contractDtoList,"pagination":_vm.pagination,"dataLoading":_vm.loading,"listCount":_vm.contractListCount},on:{"rowClicked":_vm.toSelectedItemPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }